import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "bearsteakmeat";

function GIBearSteakMeat() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIBearSteakMeat;